import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid, CircularProgress } from '@mui/material';

const StripeOnboardingReturnPage = () => {
    const getPlatform = () => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
    
            if (/android/i.test(ua)) return 'android';
            if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
            return 'web';
        };
    
        useEffect(() => {
            const platform = getPlatform();
    
            if (platform === 'ios' || platform === 'android') {
                const timer = setTimeout(() => {
                window.location.href = 'ggc:/stripe-onboarding-return';
                }, 2000); // 2-second delay

                return () => clearTimeout(timer); 
            } 
    
        }, []);
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="80vh">
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="h6" align="center">Completing...</Typography>
        </Box>
    )
}
export default StripeOnboardingReturnPage;